
define('ldsh!modules/page_generator/templates/variant_list', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<button\n  class="btn--secondary ed-dropdown-toggle"\n  type="button"\n>\n  <span\n    data-i18n="preview.variants"\n    class="js-current-variant"\n  ></span>\n  <span class="ri-arrow-down-s-line"></span>\n</button>\n\n<ul\n  role="menu"\n  class="ed-dropdown-menu ed-variants-dropdown js-variant-list"\n></ul>\n';

}
return __p
};});

